import { render, staticRenderFns } from "./VideoHeaderActions.vue?vue&type=template&id=9d3c0814&scoped=true&"
import script from "./VideoHeaderActions.vue?vue&type=script&lang=js&"
export * from "./VideoHeaderActions.vue?vue&type=script&lang=js&"
import style0 from "./VideoHeaderActions.vue?vue&type=style&index=0&id=9d3c0814&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d3c0814",
  null
  
)

export default component.exports